import { Box, IconButton, Typography } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useTranslation } from 'react-i18next'

import { useCopy, useMe } from 'src/hooks'

import { useStyles } from './styles'
import { ROUTES } from 'src/constants'
import { ReferralsTable } from './referrals-table'
import { HelperWrapper } from '../helper-wrapper'
import { TextInputWithHelper } from '../text-input-with-helper-icon'
import { CodeCard } from '../code-card'

export const InviteFriendsComponent = () => {
  const [t] = useTranslation()

  const { data: me } = useMe()

  const baseUrl = window.location.origin

  const inviteUrl = `${baseUrl}/${ROUTES.INVITE_FRIEND_REDIRECT}/${me ? me.referral_id : '...'}`
  const handleCopy = useCopy(inviteUrl)

  const classes = useStyles()

  return (
    <>
      <div className={classes.wrapperContainer}>
        <Typography variant="body1" fontWeight={600} sx={{ mb: '20px' }}>
          <HelperWrapper t="invite-friends-welcome-title" />
        </Typography>
        <Typography variant="body2" sx={{ mb: '45px' }} fontWeight={500}>
          <HelperWrapper t="invite-friends-subtitle" />
        </Typography>

        <Box
          sx={{
            width: '100%',
            mb: '20px',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '18px',
          }}
        >
          <TextInputWithHelper
            fullWidth={false}
            inputPlaceholder=""
            disabled
            inputUpperLabel={
              <HelperWrapper t={'invite-friends-referral-input-label'} isInputLable usePortal />
            }
            value={inviteUrl}
            fontSize={11}
            endIcon={
              <IconButton
                size="small"
                disabled={!inviteUrl || !me?.referral_id}
                onClick={handleCopy}
              >
                <ContentCopyIcon className={classes.copyIcon} />
              </IconButton>
            }
          />
          <CodeCard
            qrFullLink={inviteUrl}
            disableBorder
            hideTitle
            buttonsSettings={{
              download: true,
              view: false,
              copy: false,
              print: false,
              email: false,
              share: true,
            }}
          />
        </Box>
      </div>
      <ReferralsTable timezone={me?.timezone} />
    </>
  )
}
